/**
 * v-reveal 指令：元素进入视口时添加 is-in 类，配合全局 .reveal 样式做进场动画
 * 用法：<div class="reveal" v-reveal>  或  <div class="reveal" v-reveal="{ delay: 120 }">
 */
const SUPPORTED = typeof window !== 'undefined' && 'IntersectionObserver' in window

let observer = null

function getObserver() {
  if (observer) return observer
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const el = entry.target
        const delay = Number(el.dataset.revealDelay || 0)
        window.setTimeout(() => el.classList.add('is-in'), delay)
        observer.unobserve(el)
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  )
  return observer
}

export default {
  inserted(el, binding) {
    if (!SUPPORTED) {
      el.classList.add('is-in')
      return
    }
    const delay = binding.value && binding.value.delay ? binding.value.delay : 0
    el.dataset.revealDelay = String(delay)
    getObserver().observe(el)
  },
  unbind(el) {
    if (observer) observer.unobserve(el)
  }
}
